<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M15.1769 21.354L10.7406 25.7431H35.4789V29.5715H10.7406L15.1769 33.9606L12.441 36.6673L3.33398 27.6573L12.441 18.6473L15.1769 21.354ZM36.6673 12.344L27.5603 21.354L24.8244 18.6473L29.2607 14.2582H4.52244V10.4298H29.2607L24.8244 6.04073L27.5603 3.33398L36.6673 12.344Z"
      fill="#082330"
    />
  </svg>
</template>
